var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "9.02 5.54 52.98 52.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_588_5612)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.5083,
    cy: 32.0307,
    r: 26.4917,
    fill: "black",
    fillOpacity: 0.94,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8387 30.5901L38.0319 37.6399C37.9368 37.7386 37.8154 37.8058 37.6833 37.8331C37.5512 37.8603 37.4143 37.8464 37.2898 37.7929C37.1654 37.7395 37.059 37.6491 36.9842 37.5331C36.9095 37.417 36.8696 37.2806 36.8697 37.1411V33.6365C32.0114 33.922 28.6804 37.1852 27.7453 38.2188C27.5985 38.3813 27.4059 38.4916 27.1951 38.5341C26.9842 38.5766 26.7658 38.5491 26.5708 38.4556C26.3759 38.3621 26.2145 38.2072 26.1094 38.0132C26.0044 37.8191 25.9611 37.5956 25.9858 37.3746C26.3014 34.5318 27.8049 31.7973 30.2195 29.6754C32.225 27.9129 34.6626 26.7946 36.8697 26.599V23.0415C36.8696 22.902 36.9095 22.7656 36.9842 22.6495C37.059 22.5335 37.1654 22.443 37.2898 22.3896C37.4143 22.3362 37.5512 22.3223 37.6833 22.3495C37.8154 22.3768 37.9368 22.444 38.0319 22.5427L44.8387 29.5925C44.902 29.658 44.9522 29.7357 44.9864 29.8213C45.0207 29.9069 45.0383 29.9986 45.0383 30.0913C45.0383 30.1839 45.0207 30.2757 44.9864 30.3613C44.9522 30.4468 44.902 30.5246 44.8387 30.5901Z",
    fill: "#FFE227"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_588_5612",
    x: 0.775674,
    y: 0.594506,
    width: 69.4653,
    height: 69.4662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.29637
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.12046
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14902 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_588_5612"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_588_5612",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.f04e945fafa7cfc0bddd067f2ed48d22.svg";
export { ForwardRef as ReactComponent };